import {http} from '@/http/ai-http'
import {AppJson} from "@/ai-api/platformConfigApi.type";
import {GlxVo} from "@/ai-api/type";

/**
 * 查询平台基础信息（public，无需鉴权）。
 *
 * 剥别名式（070 v1.34 全站统一，与 ai_mobile platformApi 同构）：getPublic 把
 * axios baseURL 覆盖为 "/"（绕开 /ai-api/api 的默认 baseURL），故此处写全路径
 * = 别名(/ai-api) + 后端真实路径(/api/platform_config)。
 * 与 mobile 版的差异：web 侧返回完整 AppJson（logoUrl 等全字段），不做子集映射。
 */
export async function platformConfig(): Promise<AppJson> {
    const res = await http.getPublic<GlxVo<AppJson>>(`/ai-api/api/platform_config`)
    return res.data.data
}
